import moment from "moment";
import "moment-timezone";
import React from "react";
import ReactTooltip from "react-tooltip";
//import {flexi_benefits} from './mapping';
import UserInfoStores from "../stores/userInfoStores";
import i18n from "../i18nNext";
import { isEmpty } from "./is";

import forge from "node-forge";

import Mapper from "./mapping";

import history from "helper/history";
// import DefaultAutoContainerStore from "../stores/defaultAutoContainerStore"; // to handle cross button in case of mail approval.
import Api from "../constants/api";
import BASEURL from "../../config";

import NonEcmsHdfcOrgList from "./nonEcmsHdfcOrgList";
import HideBannerPostChangeHdfcOrgList from "./hideBannerPostChangeHdfcOrgList";

export default {
    _formatDate(date, format) {
        let finalDateFormat = moment
            .utc(date)
            .local()
            .format(format || "lll");
        return finalDateFormat;
    },
    _formatTime(time) {
        if (typeof time === "string" && time) {
            let finalTime = moment(`2017-01-01 ${time}`, "YYYY-MM-DD HH:mm").toDate();
            return finalTime;
        } else if (typeof time === "object") {
            return time;
        } 
            return "";
        
    },
    _formatDateinLocalTimeZone(date, format) {
        return moment(date || undefined).format(format || "lll");
    },
    _sendFormatDate(date, format) {
        let finalDateFormat = moment.utc(date).format(format || "lll");
        return finalDateFormat;
    },
    _diffBetweenDates(date1, date2, type = "days") {
        const startDate = moment(
            moment
                .utc(date1)
                .local()
                .format("YYYY-MM-DD")
        );
        const endDate = moment(
            moment
                .utc(date2)
                .local()
                .format("YYYY-MM-DD")
        );
        let needToAdd = 0;
        if (type === "days") {
            needToAdd = 1;
        }
        return endDate.diff(startDate, type) + needToAdd;
    },
    _trimTextOnly(str, length) {
        let text = str || str == 0 ? str : "";
        let trimmedString = text.length > length ? `${text.substring(0, length)}...` : text;
        return trimmedString;
    },
    _startOfMonth() {
        return moment().startOf("month");
    },
    _trimText(str, length, avoidTooltip) {
        /*return <div><span className={text}>{trimmedString}</span><Tooltip datafor={text} data={text}
		position='top'/></div>;*/

        let text = str || "";
        let trimmedString = text.length > length ? `${text.substring(0, length)}...` : text;
        if (avoidTooltip) return <span title={text}>{trimmedString}</span>;
        return (
                <span>
                    <span data-class="tooltipStyleClass" data-tip={text}>
                        {trimmedString}
                    </span>
                    <ReactTooltip />
                </span>
            );
    },
    _sortFunction(field, a, b, order, extra) {
        // console.log(54,field,a,b,order,extra);
        let viewType = localStorage.getItem("happay." + "viewType");
        if (
            a === "rpt" ||
            a === "adminExp" ||
            a === "expCat" ||
            a === "aprStatus" ||
            a === "travelSubmittedBy" ||
            a === "privNewSettlement" ||
            a === "allConfigType" ||
            a === "allConfigWallet" ||
            a === "citySort" ||
            a === "cityGrpSort" ||
            a === "user_pass_main" ||
            a === "reportDate" ||
            a === "txnTypeShort"
        ) {
            a = b || {};
            b = order || {};
            order = extra || "";
        } else if (a !== "rpt" || a === "allReportAmt") {
            if (viewType == "Privileged") {
                a = b || {};
                b = order || {};
                order = extra || "";
                a = a.object_data || {};
                b = b.object_data || {};
            }
        }
        let valueA = "";
        let valueB = "";
        if (field === "status" || field === "custom_report_status") {
            if (a && a[field]) {
                valueA = a[field].name;
            }
            if (b && b[field]) {
                valueB = b[field].name;
            }
        } else if (field === "approvalStatus") {
            valueA = a.approval_status.name;
            valueB = b.approval_status.name;
        } else if (
            (field === "submission_date" || field === "created_on" || field === "txn_date") &&
            a[field] &&
            b[field]
        ) {
            let subDateA = moment
                .utc(a[field] || undefined)
                .local()
                .format("YYYY-MM-DD");
            let subDateB = moment
                .utc(b[field] || undefined)
                .local()
                .format("YYYY-MM-DD");
            subDateA = [
                ...subDateA.split(" ")[0].split("-"),
                ...a[field].split(" ")[1].split(":")
            ].join("");
            subDateB = [
                ...subDateB.split(" ")[0].split("-"),
                ...b[field].split(" ")[1].split(":")
            ].join("");
            if (order === "desc") return subDateA - subDateB;
            return subDateB - subDateA;
        } else if (field === "reason") {
            valueA = a.reason;
            valueB = b.reason;
        } else if (field === "submitted_by") {
            valueA = a.requestor.name;
            valueB = b.requestor.name;
        } else if (field === "wallet") {
            valueA = a.wallet.name;
            valueB = b.wallet.name;
        } else if (field === "userExpAmt") {
            if (order === "desc") return a.amount - b.amount;
            return b.amount - a.amount;
        } else if (field === "userApprovedAmt") {
            if (order === "desc") return a.approved_amount - b.approved_amount;
            return b.approved_amount - a.approved_amount;
        } else if (field === "requested_amount_base") {
            if (order === "desc") return a.requested_amount_base - b.requested_amount_base;
            return b.requested_amount_base - a.requested_amount_base;
        } else if (field === "amount") {
            if (order === "desc") return a.amount - b.amount;
            return b.amount - a.amount;
        } else if (field === "approved_amount_base") {
            if (order === "desc") return a.approved_amount_base - b.approved_amount_base;
            return b.approved_amount_base - a.approved_amount_base;
        } else if (field === "empTrfStatus" && a && b) {
            valueA = a.custom_trf_status.name;
            valueB = b.custom_trf_status.name;
        } else if (field === "category") {
            valueA = a.category.name || a.category || "";
            valueB = b.category.name || b.category || "";
        } else if (field === "org_wallet") {
            valueA = a.org_wallet.name;
            valueB = b.org_wallet.name;
        } else if (field === "txn_type") {
            valueA = a.txn_type.name;
            valueB = b.txn_type.name;
        } else if (field === "city") {
            valueA = a.city.name;
            valueB = b.city.name;
        } else if (field === "city_group") {
            valueA = a.city_group.name;
            valueB = b.city_group.name;
        } else if (field === "priNewSettle") {
            valueA = a.first_name;
            valueB = b.first_name;
        } else if (field === "user_passbook") {
            if (a.user && b.user) {
                valueA = a.user.name;
                valueB = b.user.name;
            }
        } else if (field === "shared_stats") {
            if (a.shared_stats && b.shared_stats) {
                valueA = (a.shared_stats || {}).status || "";
                valueB = (b.shared_stats || {}).status || "";
            }
        }
        if (order === "desc") {
            if (valueA < valueB) return -1;
            if (valueA > valueB) return 1;
            return 0;
        } else if (order === "asc") {
            if (valueA > valueB) return -1;
            if (valueA < valueB) return 1;
            return 0;
        }
    },
    _sortEF(list, param) {
        list.sort(function compare(a, b) {
            if (a[param] < b[param]) return -1;
            if (a[param] > b[param]) return 1;
            return 0;
        });
        return list;
    },
    _sortDDListObj(list, param){
        let stArr = [], numArr = [];
        for(let i = 0 ; i < list.length ; i++){
            if(!this.isInteger(list[i][param])){
                stArr.push(list[i]);
            } else{
                numArr.push(list[i]);
            }
        }
        stArr = this._sortEF(stArr, param);
        numArr = numArr.sort(function compare(a, b) {
            if (+a[param] < +b[param]) return -1;
            if (+a[param] > +b[param]) return 1;
            return 0;
        });
        const tempArr = [...numArr, ...stArr];
        // list = list.sort((a, b) => {
        //     if(this.isInteger(a[param]) && this.isInteger(b[param])){
        //         return +a[param] > +b[param] ? 1 : -1;
        //     } else {
        //         // this is for those cases which have a[param] is an integer value and b[param] is a string value or vice versa
        //         const tempA = this.isInteger(a[param]) ? +a[param] : `9999999999${a[param]}`;
        //         const tempB = this.isInteger(b[param]) ? +b[param] : `9999999999${b[param]}`;
        //         return tempA < tempB;
        //     }
        // })
        return tempArr;
    },
     isInteger (n){
        return !isNaN(parseFloat(+n)) ? true : false;
    },
    byField(field1, field2) {
        return (a, b) => {
            if (a[field1] === b[field1]) {
                if (a[field2].toLowerCase() < b[field2].toLowerCase()) return -1;
                if (a[field2].toLowerCase() > b[field2].toLowerCase()) return 1;
            } else {
                if (a[field1] < b[field1]) return -1;
                if (a[field1] > b[field1]) return 1;
            }
        };
    },

    _sortDropdown(list = {}, param, isNumber, fromPage, secondaryParam) {
        if (param == "extra_field") {
            let newList = {};
            let key = Object.keys(list).sort() || [];
            key.forEach(i => {
                newList[i] = i;
            });
            return newList;
        }
        list.sort(function compare(a, b) {
            if (isNumber) {
                //following code is added by abhinav, to sort the trf configs on the basis of secondaryParam(name) when param(order no) is same
                if (fromPage && a[param] === b[param]) {
                    if (a[secondaryParam].toUpperCase() < b[secondaryParam].toUpperCase())
                        return -1;
                    if (a[secondaryParam].toUpperCase() > b[secondaryParam].toUpperCase()) return 1;
                    return 0;
                }
                return a[param] - b[param];
            }
            if (a[param].toUpperCase() < b[param].toUpperCase()) return -1;
            if (a[param].toUpperCase() > b[param].toUpperCase()) return 1;
            return 0;
        });
        return list;
    },
    _sortNestedDropdown(arr, key, childParam) {
        arr.forEach(el => {
            if (!el[childParam]) return;
            else if (el[childParam] && el[childParam].length)
                return this._sortNestedDropdown(el[childParam], key, childParam);
        });
        return this._sortDropdown(arr, key);
    },
    _mappingWeekDays(no) {
        let day = "";
        if (no == "1") day = "Monday";
        else if (no == "2") day = "Tuesday";
        else if (no == "3") day = "Wednesday";
        else if (no == "4") day = "Thursday";
        else if (no == "5") day = "Friday";
        else if (no == "6") day = "Saturday";
        else if (no == "7") day = "Sunday";

        return day;
    },
    _mappingMonthDays(no) {
        let day = "";
        let num = parseInt(no);
        if (num == 1) day = `${no}st`;
        else if (num == 2) day = `${no}nd`;
        else if (num == 3) day = `${no}rd`;
        else day = `${no}th`;
        return day;
    },
    _capitalizeFirstLetter(string, force) {
        if (string) {
            let newString = string;
            if (force) {
                newString = string.toLowerCase();
            }
            return newString.charAt(0).toUpperCase() + newString.slice(1);
        }
    },
    _perfectClone(input) {
        if (input === null || typeof input !== "object" || !isNaN(Date.parse(input))) {
            return input;
        }
        const output = Array.isArray(input) ? [] : {};
        for (const key of Object.keys(input)) {
            output[key] = this._perfectClone(input[key]);
        }

        return output;
    },
    _numberToCurrencyFormat(value) {
        return parseFloat(value)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    _getIntervalsBetweenTwoDates(startDateString, endDateString, type) {
        let startDate = moment.utc(startDateString).local();
        let endDate = moment.utc(endDateString).local();
        let allIntervals = [];
        let currFormat = "YYYY";
        let finalObj = {};
        let noOfDays = endDate.diff(startDate, "days");

        while (startDate.isBefore(endDate)) {
            if (type == "year") {
                currFormat = "YYYY";
                allIntervals.push(startDate.format("YYYY"));
                startDate = startDate.add(1, "years");
            } else if (type == "month") {
                currFormat = "MMM-YYYY";
                allIntervals.push(startDate.format("MMM-YYYY"));
                startDate = startDate.add(1, "months");
            } else if (type == "week") {
                currFormat = "YYYY-MM-DD";
                allIntervals.push(
                    moment(startDate, "YYYY-MM-DD")
                        .startOf("isoweek")
                        .format("YYYY-MM-DD")
                );
                startDate = startDate.add(1, "days");
            } else if (type == "day") {
                currFormat = "YYYY-MM-DD";
                allIntervals.push(startDate.format("YYYY-MM-DD"));
                startDate = startDate.add(1, "days");
            }
        }

        if (type != "week") {
            let lastEL = endDate.format(currFormat);
            if (!allIntervals.includes(lastEL)) allIntervals.push(endDate.format(currFormat));
        }

        finalObj = {
            allIntervals: [...new Set(allIntervals)], // To make sure no duplicate items
            currFormat
        };
        return finalObj;
    },
    _scrollIntoView(id) {
        if (id && document.getElementById(id)) {
            document.getElementById(id).scrollIntoView();
        }
    },
    /**
     *
     * @param {*} identifierType - id or class or other specified attribute
     * @param {*} identifier - id name or className or other specified attribute key,value
     * @param {*} type - resourse_name
     * @param {*} offsetValue - modified offset value (+,-,*)
     */

    _scrollToElement(identifierType, identifier, type, offsetValue) {
        let offset = 0;
        let offsetEle;
        if (identifierType === "id") {
            offsetEle = document.querySelector(`#field-${identifier}`);
        } else if (identifierType === "class") {
            offsetEle = document.querySelector(`.${identifier}`);
        } else if (identifierType === "other") {
            offsetEle = document.querySelector(`[${identifier}]`);
        }

        if (offsetEle) {
            offset = offsetEle.offsetTop;
        }

        let newType = type;
        if (type === "user") {
            newType = ".mdl-layout__content";
        } else {
            newType = `#${type}`;
        }

        const element = document.querySelector(newType);
        const specifiedElement = document.querySelector(`#field-${identifier}`);
        const inputField = document.querySelector(`#field-${identifier} input`);
        try {
            if (element) {
                element.scrollTo({
                    top: offset + offsetValue,
                    left: 0,
                    behavior: "smooth"
                });
                if (specifiedElement && specifiedElement.hasAttribute("data-fType")) {
                    if (inputField) {
                        if (
                            !window.navigator.userAgent.includes("Edg") &&
                            !window.navigator.userAgent.includes("Firefox")
                        ) {
                            inputField.focus();
                        } else {
                            specifiedElement.scrollIntoView({ behavior: "smooth" });
                        }
                    }
                }
            } else {
                window.scrollTo(0, offset);
            }
        } catch (error) {
            element.scrollTop = offset;
            if (specifiedElement && specifiedElement.hasAttribute("data-fType")) {
                if (inputField) inputField.focus();
            }
        }
    },
    _formatBookingDate(date, fromItn) {
        if (fromItn == "fromItn" || fromItn == "managebooking") {
            let formattedDate = `${moment.utc(date).format("ddd")}, ${moment
                .utc(date)
                .format("Do MMM YYYY")}`;
            return formattedDate;
        } else if (fromItn === "fromMngBooking") {
            let formattedDate = `${moment.utc(date).format("DD MMM, YYYY")} | ${moment
                .utc(date)
                .format("ddd")}`;
            return formattedDate;
        } else if (fromItn === "basicfilter") {
            if (
                window.navigator.userAgent.includes("Chrome") ||
                window.navigator.userAgent.includes("Firefox")
            ) {
                let formattedDate = `${moment
                    .utc(date)
                    .local()
                    .format("ddd")} ${moment
                    .utc(date)
                    .local()
                    .format("DD MMM, YYYY")}`;
                return formattedDate;
            } else if (window.navigator.userAgent.includes("Safari")) {
                let formattedDate = `${moment.utc(date).format("ddd")} ${moment
                    .utc(date)
                    .format("DD MMM, YYYY")}`;
                return formattedDate;
            }
        } else if (fromItn === "fromMyBooking") {
            let formattedDate = `${moment.utc(date).format("ddd")}  ${moment
                .utc(date)
                .format("DD MMM, YYYY")}  ${moment.utc(date).format("HH:mm")}`;
            return formattedDate;
        } else {
            let formattedDate = `${moment
                .utc(date)
                .local()
                .format("Do MMMM YYYY")} | ${moment
                .utc(date)
                .local()
                .format("dddd")}`;
            return formattedDate;
        }
    },
    _formatBookingUrlDate(date) {
        let formattedDate = moment
            .utc(date)
            .local()
            .format("MM-DD-YYYY");
        return formattedDate;
    },
    _formatBookingTime(date, type) {
        if (type == "CardContainer") {
            let formattedTime = moment(date).format("HH:mm");
            return formattedTime;
        } 
            let formattedTime = moment.utc(date).format("HH:mm");
            return formattedTime;
        
    },
    _itnTotalDuration(depart, arrive) {
        let dep = moment(new Date(depart));
        let arr = moment(new Date(arrive));
        let final = `${arr.diff(dep, "hours")}h ${arr.diff(dep, "minutes") % 60}m`;
        return final;
    },
    _totalDuration(seconds, type) {
        let formatted = moment.utc(seconds * 1000).format("HH:mm:ss");
        let dateformat = formatted.split(":");

        if (type === "search") return dateformat[0] * 60 + +dateformat[1];
        else if (type === "long-layover") return dateformat[0];
        return `${dateformat[0]}h ${dateformat[1]}mins`;
    },
    calculateDOB(type) {
        if (type == "CHD")
            return moment()
                .subtract(10, "years")
                .format("YYYY-MM-DD");
        return moment()
                .subtract(1, "years")
                .format("YYYY-MM-DD");
    },
    _decideDay(arr, dep) {
        let dept = moment(dep, "YYYYMMDD");
        let arrv = moment(arr, "YYYYMMDD");
        let f = arrv.diff(dept, "days");
        return f;
    },
    calcLayover(dep, arr) {
        let depart = moment(dep);
        let arrival = moment(arr);
        let final = `${arrival.diff(depart, "hours")}h ${arrival.diff(depart, "minutes") % 60}m`;
        return final;
    },
    _calctotalDuration(seconds, type) {
        if (type == "search") {
            return seconds / 60;
        }
        let dateformat = seconds / 3600;
        dateformat = `${dateformat}`;
        let sec = `0.${dateformat.split(".")[1]}`;
        sec = parseFloat(sec) * 60;
        sec = `${sec}`;
        return `${dateformat.split(".")[0]}h ${sec.split(".")[0]}mins `;
    },
    formatTime(time) {
        return moment(time).format("HH:mm");
    },

    _isNumber(num) {
        return !isNaN(parseFloat(num)) && isFinite(num);
    },
    _toCamelCase(tempStr) {
        tempStr = tempStr || "";
        const str = tempStr.toLowerCase();
        return str
            .replace(/\s(.)/g, $1 => {
                return $1.toUpperCase();
            })
            .replace(/\s/g, "")
            .replace(/^(.)/, $1 => {
                return $1.toLowerCase();
            });
    },
    _flexiDynamicData(id, text) {
        let data;
        try {
            data =
                JSON.parse(localStorage.getItem("flexiElements")) || UserInfoStores._getFlexiType();
        } catch (e) {
            data = UserInfoStores._getFlexiType();
        }
        if (data && data[id]) {
            return !data[id].hidden
                ? data[id].text || i18n.t(`flexi.${this._toCamelCase(text)}`)
                : null;
        }
        return i18n.t(`flexi.${this._toCamelCase(text)}`);
    },
    _calculatePosition(el) {
        let xPos = 0;
        let yPos = 0;

        while (el) {
            if (el.tagName == "BODY") {
                // deal with browser quirks with body/window/document and page scroll
                const xScroll = el.scrollLeft || document.documentElement.scrollLeft;
                const yScroll = el.scrollTop || document.documentElement.scrollTop;

                xPos += el.offsetLeft - xScroll + el.clientLeft;
                yPos += el.offsetTop - yScroll + el.clientTop;
            } else {
                // for all other non-BODY elements
                xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
                yPos += el.offsetTop - el.scrollTop + el.clientTop;
            }

            el = el.offsetParent;
        }
        return {
            x: xPos,
            y: yPos
        };
    },

    // common function to get currencyListMap
    _getCurrencyFromCurrencyList({ currency_list = [] }, currencyListMap) {
        currency_list.forEach(({ currency_code, alpha_code }) => {
            currencyListMap[currency_code] = UserInfoStores.getCurrencySymbol(alpha_code);
        });
        return currencyListMap;
    },

    //Gereric function to draw policy voilation list
    _recursive_draw_policy_warning_msg(data) {
        let newStructForMessages = [];
        if (data && data.length) {
            data.forEach((el, i) =>
                Object.values(el).forEach((sub_el, j) =>
                    Object.values(sub_el).forEach((sub_sub_el, k) => {
                        if (sub_sub_el.hasOwnProperty("violations")) {
                            return (sub_sub_el.violations || []).forEach((item, p) => {
                                let policy_color = "red";
                                if (item.notification === "W" || item.notification === "w") {
                                    policy_color = "#fcb74e";
                                }
                                if (item.msg.includes('"')) {
                                    item.msg = item.msg.replace(/"/g, "'");
                                }
                                let lineItemHTML = `<li style='line-height:15px;color:${policy_color}'><span style='color:#fff'>${item.msg}</span></li>`;
                                newStructForMessages.push(lineItemHTML);
                                return lineItemHTML;
                                //return (<li key={`${i}_${j}_${k}_${p}`} style={{lineHeight:"15px",color:policy_color}}><span style={{color:"#fff"}}>{item.msg}</span></li>);
                            });
                        } else if ("msg" in sub_sub_el) {
                            let policy_color = "red";
                            if (
                                sub_sub_el.notification === "W" ||
                                sub_sub_el.notification === "w"
                            ) {
                                policy_color = "#fcb74e";
                            }
                            if (sub_sub_el.msg.includes('"')) {
                                sub_sub_el.msg = sub_sub_el.msg.replace(/"/g, "'");
                            }
                            let lineItemHTML = `<li style='line-height:15px;color:${policy_color}'><span style='color:#fff'>${sub_sub_el.msg}</span></li>`;
                            newStructForMessages.push(lineItemHTML);
                            return lineItemHTML;
                            //return (<li key={`${i}_${j}_${k}`} style={{lineHeight:"15px",color:policy_color}}><span style={{color:"#fff"}}>{sub_sub_el.msg}</span></li>);
                        }
                    })
                )
            ) || [];
        }
        return newStructForMessages;
    },
    numberToText(value) {
        const fraction = Math.round(this.frac(value) * 100);
        let f_text = "";

        if (fraction > 0) {
            f_text = `and ${this.convert_number(fraction)} Paise`;
        }

        return `${this.convert_number(value)} Rupees ${f_text} only`;
    },

    frac(f) {
        return f % 1;
    },

    convert_number(number) {
        if (number < 0 || number > 999999999) {
            return "NUMBER OUT OF RANGE!";
        }
        const Gn = Math.floor(number / 10000000); /* Crore */
        number -= Gn * 10000000;
        const kn = Math.floor(number / 100000); /* lakhs */
        number -= kn * 100000;
        const Hn = Math.floor(number / 1000); /* thousand */
        number -= Hn * 1000;
        const Dn = Math.floor(number / 100); /* Tens (deca) */
        number = number % 100; /* Ones */
        const tn = Math.floor(number / 10);
        const one = Math.floor(number % 10);
        let res = "";

        if (Gn > 0) {
            res += `${this.convert_number(Gn)} Crore`;
        }
        if (kn > 0) {
            res += `${(res == "" ? "" : " ") + this.convert_number(kn)} Lakh`;
        }
        if (Hn > 0) {
            res += `${(res == "" ? "" : " ") + this.convert_number(Hn)} Thousand`;
        }

        if (Dn) {
            res += `${(res == "" ? "" : " ") + this.convert_number(Dn)} Hundred`;
        }

        const ones = [
            "",
            "One ",
            "Two ",
            "Three ",
            "Four ",
            "Five ",
            "Six ",
            "Seven ",
            "Eight ",
            "Nine ",
            "Ten ",
            "Eleven ",
            "Twelve ",
            "Thirteen ",
            "Fourteen ",
            "Fifteen ",
            "Sixteen ",
            "Seventeen ",
            "Eighteen ",
            "Nineteen "
        ];
        const tens = [
            "",
            "",
            "Twenty",
            "Thirty",
            "Forty",
            "Fifty",
            "Sixty",
            "Seventy",
            "Eighty",
            "Ninety"
        ];
        if (tn > 0 || one > 0) {
            if (!(res == "")) {
                res += " and ";
            }
            if (tn < 2) {
                res += ones[tn * 10 + one];
            } else {
                res += tens[tn];
                if (one > 0) {
                    res += `-${ones[one]}`;
                }
            }
        }

        if (res == "") {
            res = "zero";
        }
        return res;
    },

    getMonths(i = 0) {
        return [
            { id: `${i}`, name: i18n.t("common.january") },
            { id: `${++i}`, name: i18n.t("common.february") },
            { id: `${++i}`, name: i18n.t("common.march") },
            { id: `${++i}`, name: i18n.t("common.april") },
            { id: `${++i}`, name: i18n.t("common.may") },
            { id: `${++i}`, name: i18n.t("common.june") },
            { id: `${++i}`, name: i18n.t("common.july") },
            { id: `${++i}`, name: i18n.t("common.august") },
            { id: `${++i}`, name: i18n.t("common.september") },
            { id: `${++i}`, name: i18n.t("common.october") },
            { id: `${++i}`, name: i18n.t("common.november") },
            { id: `${++i}`, name: i18n.t("common.december") }
        ];
    },
    getSirname() {
        return [
            { value: "Miss", text: i18n.t("common.miss") },
            { value: "Mr", text: i18n.t("common.mr") },
            { value: "Mrs", text: i18n.t("common.mrs") },
            { value: "Ms", text: i18n.t("common.ms") },
            { value: "PNS", text: i18n.t("common.preferNotSay") }
        ];
    },
    getGender() {
        return [
            { value: "Female", text: i18n.t("common.female") },
            { value: "Male", text: i18n.t("common.male") },
            { value: "Other", text: i18n.t("common.other") },
            { value: "PNS", text: i18n.t("common.preferNotSay") },
            { value: "Third gender", text: i18n.t("common.thirdGender") }
        ];
    },
    addMonths(date, months) {
        date.setMonth(date.getMonth() + months);
        return date;
    },
    _getMonth(date) {
        let mon = date.getMonth() + 1;
        if (mon < 10) {
            return `0${mon}`;
        }
        return mon;
    },

    getWeekDays(i = 0) {
        return [
            { id: `${i === 1 ? 7 : 0}`, name: i18n.t("common.sunday") },
            { id: "1", name: i18n.t("common.monday") },
            { id: "2", name: i18n.t("common.tuesday") },
            { id: "3", name: i18n.t("common.wednesday") },
            { id: "4", name: i18n.t("common.thursday") },
            { id: "5", name: i18n.t("common.friday") },
            { id: "6", name: i18n.t("common.saturday") }
        ];
    },

    getMonths(i = 0) {
        return [
            { id: `${i}`, name: i18n.t("common.january") },
            { id: `${++i}`, name: i18n.t("common.february") },
            { id: `${++i}`, name: i18n.t("common.march") },
            { id: `${++i}`, name: i18n.t("common.april") },
            { id: `${++i}`, name: i18n.t("common.may") },
            { id: `${++i}`, name: i18n.t("common.june") },
            { id: `${++i}`, name: i18n.t("common.july") },
            { id: `${++i}`, name: i18n.t("common.august") },
            { id: `${++i}`, name: i18n.t("common.september") },
            { id: `${++i}`, name: i18n.t("common.october") },
            { id: `${++i}`, name: i18n.t("common.november") },
            { id: `${++i}`, name: i18n.t("common.december") }
        ];
    },
    // getSirname() {
    //     return [
    //         { id: "Miss", name: i18n.t("common.miss") },
    //         { id: "Mr", name: i18n.t("common.mr") },
    //         { id: "Mrs", name: i18n.t("common.mrs") },
    //         { id: "PNS", name: i18n.t("common.preferNotSay") }
    //     ];
    // },
    // getGender() {
    //     return [
    //         { id: "Female", name: i18n.t("common.female") },
    //         { id: "Male", name: i18n.t("common.male") },
    //         { id: "Other", name: i18n.t("common.other") },
    //         { id: "PNS", name: i18n.t("common.preferNotSay") },
    //         { id: "Third gender", name: i18n.t("common.thirdGender") }
    //     ];
    // },
    addMonths(date, months) {
        date.setMonth(date.getMonth() + months);
        return date;
    },
    _getMonth(date) {
        let mon = date.getMonth() + 1;
        if (mon < 10) {
            return `0${mon}`;
        }
        return mon;
    },

    _getSystemTimeZoneByName() {
        return moment.tz.guess(); // output i.e "Asia/Culcutta"
        // return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    _getTimeZoneOffset() {
        return new Date().getTimezoneOffset(); // output i.e -330
    },
    _getCustomTimeZoneOffset() {
        return moment().format("Z");
        // var offset = new Date().getTimezoneOffset(),
        //     o = Math.abs(offset);

        // return (
        //     // output i.e +5:30
        //     (offset < 0 ? "+" : "-") + Math.floor(o / 60) + ":" + ("00" + (o % 60)).slice(-2)
        // );
    },
    _getTimeZone() {
        return /\((.*)\)/.exec(new Date().toString())[1]; //  output i.e "indian standard time"
    },
    _getTimeZoneAbbr(timezone = moment.tz.guess()) {
        return moment.tz(timezone).zoneAbbr(); // output i.e "IST"
    },
    _formatDateTimeUTCTimezone(cell, timezone = moment.tz.guess(), format = "DD MMM YYYY h:mm a") {
        return moment
            .utc(cell)
            .tz(timezone)
            .format(format);
    },
    _get(object, keys, defaultVal) {
        if (!object) return defaultVal;

        let getProps = function inner(object, keys, defaultVal) {
            keys = Array.isArray(keys) ? keys : keys.split(".");
            object = object[keys[0]];
            if (object && keys.length > 1) {
                return inner(object, keys.slice(1), defaultVal);
            }
            return object === undefined ? defaultVal : object;
        };

        return getProps(object, keys, defaultVal);
    },
    _copyToClipBoard(text) {
        let element = document.createElement("textarea");
        document.body.appendChild(element);
        element.value = text;
        element.select();
        document.execCommand("copy");
        document.body.removeChild(element);
        UserInfoStores.showToast("Copied to clipboard  succesfully!", 0);
    },
    _replaceUnderScoreToSpc(data) {
        return data
            .split("_")
            .join(" ")
            .toUpperCase();
    },
    _getValidValue(type) {
        switch (type) {
            case undefined:
                return false;
            case null:
                return false;
            default:
                return true;
        }
    },
    _getAge(birthDate) {
        return Math.floor((new Date() - new Date(birthDate).getTime()) / 3.15576e10);
    },
    _changeWordToFlexiWordInString(str) {
        let newStr = str;
        let keywordMap = this._getkeywordMap();
        for (let key in keywordMap) {
            newStr = newStr.replace(new RegExp(key, "ig"), keywordMap[key]);
        }
        return newStr;
    },
    _getkeywordMap() {
        return {
            Expense: this._flexiDynamicData("keyWord_0", "Expense"),
            Report: this._flexiDynamicData("keyWord_1", "Report"),
            "Travel Request": this._flexiDynamicData("keyWord_5", "Travel Request"),
            Wallet: this._flexiDynamicData("keyWord_8", "Wallet")
        };
    },
    truncate(str = "", maxlength) {
        return str.length > maxlength ? str.slice(0, maxlength - 1) + "…" : str;
    },
    _getUserShortName(name = "") {
        let arr = name.split(" ");
        if (arr.length < 2) {
            return arr[0] ? arr[0][0].toUpperCase() : "";
        } 
            return `${name[0]}${arr[arr.length - 1][0]}`.toUpperCase();
        
    },
    downloadCSV(title, csv) {
        const hiddenElement = document.createElement("a");
        hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csv)}`;
        hiddenElement.target = "_blank";
        hiddenElement.download = `${title}.csv`;
        hiddenElement.click();
    },
    uniqId() {
        // Math.random should be unique because of its seeding algorithm.
        // Convert it to base 36 (numbers + letters), and grab the first 9 characters
        // after the decimal.
        return `_${Math.random()
            .toString(36)
            .substr(2, 9)}`;
    },
    newRecursiveDrawPolicyWarningMsg(data = [], uniqueMessageArr = []) {
        const newStructForMessages = [];
        if (isEmpty(data)) return newStructForMessages;

        data.forEach(obj => {
            Object.values(obj).forEach(subElm => {
                Object.values(subElm).forEach(({ violations, msg, notification }) => {
                    if (!uniqueMessageArr.includes(msg)) {
                        if (violations) {
                            violations.forEach(({ msg: message, notification }) => {
                                if (!uniqueMessageArr.includes(message)) {
                                    this.newStructMessageFn(
                                        message,
                                        uniqueMessageArr,
                                        newStructForMessages,
                                        notification
                                    );
                                }
                            });
                        } else if (msg) {
                            this.newStructMessageFn(
                                msg,
                                uniqueMessageArr,
                                newStructForMessages,
                                notification
                            );
                        }
                    }
                });
            });
        });

        return newStructForMessages;
    },
    newStructMessageFn(msg, uniqueMessageArr, newStructForMessages, notification) {
        let message = msg;
        if (message.includes('"')) {
            message = message.replace(/"/g, "'");
        }
        uniqueMessageArr.push(message);
        newStructForMessages.push({ message, notification });
        return message;
    },
    queryString(params) {
        return Object.keys(params)
            .map(key => `${key}=${params[key]}`)
            .join("&");
    },
    hexToRgbColor(hex) {
        const normal = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
        if (normal) return normal.slice(1).map(e => parseInt(e, 16));
        const shorthand = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
        if (shorthand) return shorthand.slice(1).map(e => 0x11 * parseInt(e, 16));
        return null;
    },
    commonAvatarLoad(ev) {
        if (ev && ev.target) {
            const tempH = ev.target.naturalHeight / ev.target.naturalWidth;
            const tempW = ev.target.naturalWidth / ev.target.naturalHeight;
            const notNormalImg = tempH > 1 || tempW > 1;
            ev.target.classList.remove("avatar-hide");
            ev.target.nextElementSibling.classList.add("avatar-hide");
            if (notNormalImg) {
                ev.target.classList.add("avatar-not-normal");
                if (tempH > 1 && tempH <= 1.9) {
                    ev.target.style.height = `${Math.round(tempH * 100)}%`;
                    ev.target.style.width = "auto";
                } else if (tempW > 1 && tempW <= 1.9) {
                    ev.target.style.width = `${Math.round(tempW * 100)}%`;
                    ev.target.style.height = "auto";
                } else {
                    ev.target.style.width = "";
                    ev.target.style.height = "";
                }
            } else {
                ev.target.classList.remove("avatar-not-normal");
            }
        }
    },

    encryptedDataUsingForge(publicEncryptionKey, data) {
        const decodePublicKey = forge.util.decode64(publicEncryptionKey);
        const publicKey = forge.pki.publicKeyFromPem(decodePublicKey);
        // const encrypted = publicKey.encrypt(data);
        const encrypted = publicKey.encrypt(data, "RSA-OAEP", {
            md: forge.md.sha256.create()
        });
        const base64Encrypted = forge.util.encode64(encrypted);
        return base64Encrypted;
    },

    formatTableData(data) {
        const tempData = data || [];
        let finalData = [];
        if (tempData.length) {
            finalData = tempData.map(item => {
                const extraFieldId = item && item.report_id;
                const extfieldData = item.extra_fields[extraFieldId];
                const tempObj = {};
                for (let key in extfieldData) {
                    if (
                        extfieldData[key].name_type == "dropdown" ||
                        extfieldData[key].name_type == "multi_select_dropdown"
                    ) {
                        if (
                            extfieldData[key] &&
                            extfieldData[key].field_value &&
                            typeof extfieldData[key].field_value === "object"
                        ) {
                            tempObj[key] = extfieldData[key].field_value.join();
                        } else {
                            tempObj[key] = extfieldData[key].field_value;
                        }
                    } else if (extfieldData[key].name_type == "file") {
                        if (
                            extfieldData[key] &&
                            extfieldData[key].field_value &&
                            Object.keys(extfieldData[key].field_value).length
                        ) {
                            tempObj[key] = Object.values(extfieldData[key].field_value);
                        } else {
                            tempObj[key] = "";
                        }
                    } else if (extfieldData[key].name_type == "con_type") {
                        if (
                            extfieldData &&
                            extfieldData[key] &&
                            extfieldData[key].field_value &&
                            Object.keys(extfieldData[key].field_value).length
                        ) {
                            tempObj[key] = extfieldData[key].field_value.value;
                        }
                    } else {
                        tempObj[key] = extfieldData[key].field_value;
                    }
                }
                return Object.assign(item, tempObj);
            });
        } else {
            finalData = data;
        }
        return finalData;
    },

    isFromMailApproval(container_type, viewType, fromInMail) {
        if (history.length === 1 || fromInMail === "true") {
            let url = "/";
            if (viewType === "Privileged") {
                url += "pending/";
            }
            if (container_type?.id === Mapper["REPORT"]) url += "report";
            else if (container_type?.id === Mapper["TRF"]) url += "travel";
            else if (container_type?.id === Mapper["MONEY_REQUEST"])
                url += "moneyrequest";
            else if (container_type?.id === Mapper["CARD_LOAD"])
                url += "cardload";
            
            return url;
        }
        return false;
    },

    _sortMonth(data) {
        let months = ["December", "November", "October", "September", "August", "July", "June", 
        "May", "April", "March", "February", "January"];
        let newMonthList = [];
        for(let i=0; i< months.length; i += 1) {
            if (data[months[i]]) {
                newMonthList.push({
                ...data[months[i]],
                key: months[i]
              });
            }
          }
        return newMonthList;
    },

    // Add Zero if number is Less than 10
    _addZeroBeforNumber(number) {
        if (number < 10) return `0${number}`;
        return number;
    },
    
    _financialYear(date, period, format) {
        const month = parseInt(Api._formatDate(date, "MM"));
        const year = parseInt(Api._formatDate(date, "YYYY"));
        if (format === "MM") {
            if (period === "Jan/Dec") return Api._formatDate(date, format);
            else if (period === "Apr/Mar")
                if (month <= 3) return month + 9;
                else return this._addZeroBeforNumber(month - 3);
        } else if (format === "MMYYYY") {
            if (period === "Jan/Dec") return Api._formatDate(date, format);
            else if (period === "Apr/Mar")
                if (month <= 3) {
                    return `${month + 9}${year}`;
                } else {
                    const monthWithZero = this._addZeroBeforNumber(month - 3);
                    return `${monthWithZero}${year + 1}`;
                }
        } else if (format === "YYYYMM") {
            if (period === "Jan/Dec") return Api._formatDate(date, format);
            else if (period === "Apr/Mar")
                if (month <= 3) {
                    return `${year}${month + 9}`;
                } else {
                    const monthWithZero = this._addZeroBeforNumber(month - 3);
                    return `${year + 1}${monthWithZero}`;
                }
        } else if (format === "MM/YYYY") {
            if (period === "Jan/Dec") return Api._formatDate(date, format);
            else if (period === "Apr/Mar")
                if (month <= 3) {
                    return `${month + 9}${"/"}${year}`;
                } else {
                    const monthWithZero = this._addZeroBeforNumber(month - 3);
                    return `${monthWithZero}${"/"}${year + 1}`;
                }
        } else if (format === "FYYY") {
            if (period === "Apr/Mar")
                if (month <= 3) return `${"FY"}${year}`;
                else return `${"FY"}${year + 1}`;
        } else if (format === "MM(in letters)FYYY") {
            if (period === "Apr/Mar") {
                const lastTwoDigitYear = year.toString().substring(2);
                if (month <= 3) {
                    return `${Api._formatDate(date, "MMM")}${"FY"}${+lastTwoDigitYear}`;
                } 
                    return `${Api._formatDate(date, "MMM")}${"FY"}${+lastTwoDigitYear + 1}`;
                
            }
        } else if (format === "MM(in number)FYYY") {
            if (period === "Apr/Mar") {
                const lastTwoDigitYear = year.toString().substring(2);
                if (month <= 3) {
                    return `${month + 9}${"FY"}${+lastTwoDigitYear}`;
                } 
                    const monthWithZero = this._addZeroBeforNumber(month - 3);
                    return `${monthWithZero}${"FY"}${+lastTwoDigitYear + 1}`;
                
            }
        }
    },
    createScrpitTagDynamically(url = "", cb = () => {}) {
        if (url && document.querySelector(`[src="${url}"]`)) {
            // If script tag is already there in the DOM the call the callback
            if (typeof cb === "function") {
                cb();
            }
            return;
        }
        const scriptEle = document.createElement("script");
        if(cb) {            
            scriptEle.onload = function() {
                cb();
            };
        }
        scriptEle.setAttribute("src", url);
        scriptEle.setAttribute("type", "text/javascript");
        scriptEle.setAttribute("async", true);
        scriptEle.setAttribute("defer", true);
        document.body.appendChild(scriptEle);
    },
    
    isScriptLoaded(url) {
        try {
            if (url && document.querySelector(`[src="${url}"]`)) {
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    },

    _getCompanyUseCase(type) {
        let compUseCase = UserInfoStores.getAllUserInfoStores()?.company_use_case;
        if (compUseCase?.[type] === 0){
            return true;
        }
        return false;
    },

    _enableXpendite(){
        const enableXpendite = [
            "HPORG2019386991034696740HP",
            "HPORG20191015549207109721203HP",
            "HPORG2019129548222899711HP",
            "HPORG2019710624529251312161HP"
        ];
        if (
            process.env.NODE_ENV === "production" &&
            window.location.protocol === "https:" &&
            BASEURL === "https://api-v2.happay.in/"
        ) {
            return enableXpendite.includes(Api._getKey("org_id"));
        } 
        return true;
    },

    _scrollContentToLeft(id) {
        const element = document.querySelector(id); // id: In which scroll has been added
        const scrollLeftPostion = element?.scrollLeft; // returns the horizontal scroll position
        element.scrollBy({
            left: -(scrollLeftPostion), // negative value to scroll left
            behavior: 'smooth' // optional, adds smooth scrolling animation
          });
    },

    twoDecimalPlaceWithoutRoundingOff(value) {
        return Math.floor(value * 100) / 100;
    },
    
    _validateVideoUrl(url) {
        // Regular expression for YouTube video URLs
        const youtubeRegex = /^(https?:\/\/)?(www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]{11})$/;

        // Regular expression for non-YouTube video URLs
        const videoRegex = /^(https?:\/\/)?(www\.)?.+\.(mp4|avi|mov|wmv)$/;
        
        if (!url.includes("https")) {
            UserInfoStores.showToast(i18n.t("helpCenter.pleaseEnterHttps"));
            return false;
        }
        if (url.includes("youtube")) {
            if (!youtubeRegex.test(url)) {
                UserInfoStores.showToast(i18n.t("helpCenter.youtubeEmbedUrl"));
                return false;
            }
        } else if (!videoRegex.test(url)) {
            UserInfoStores.showToast(i18n.t("helpCenter.pleaseEnterValidUrl"));
            return false;
        }
        return true;
    },

    _checkIfHdfcUrl() {
        const hostName = window.location.hostname;
        if(hostName.includes("hdfcbank.poweredby")) return true;
        return false;
    },

    _getAdminAppURL() {
        const hostName = window.location.hostname;
        const iframeURL = hostName.substring(hostName.indexOf("."));
        let prefixURL = "";
        if(hostName.includes("hdfcbank.poweredby")) {
            /**
             * if URL is https://uat-hdfcbank.poweredby.happay.in/login
             * then Admin URL will be: https://admin-uat-hdfcbank.poweredby.happay.in/
             * 
             * if URL is https://hdfcbank.poweredby.happay.in/login
             * then Admin URL will be : https://admin-hdfcbank.poweredby.happay.in/
             * 
             * TODO: Local mapping can be added here in the logic
             */
            prefixURL = `-${hostName.substring(0, hostName.indexOf("."))}`;
        }

        return `https://admin${prefixURL}${iframeURL}/`;
    },
    isNonEcmsHdfcOrg(orgId) {
        orgId = orgId || "";
        return NonEcmsHdfcOrgList?.includes(orgId);
    },
    
    isHideBannerPostChangeHdfcOrgList(orgId) {
        orgId = orgId || "";
        return HideBannerPostChangeHdfcOrgList?.includes(orgId);
    }

};
